import React from 'react'
import { motion } from 'framer-motion'

const Overlay = () => {
  return (
    <motion.div
      animate={{
        opacity: 1,
      }}
      initial={{
        opacity: 0,
      }}
      exit={{
        opacity: 0,
      }}
      transition={{ ease: 'easeOut', duration: 0.15 }}
      className={'dark-overlay'}
    />
  )
}

export default Overlay
